import { render } from "./DepositNft.vue?vue&type=template&id=418c94f0&scoped=true"
import script from "./DepositNft.vue?vue&type=script&lang=js"
export * from "./DepositNft.vue?vue&type=script&lang=js"

import "@/Common/Styles/depositNft.scss?vue&type=style&index=0&id=418c94f0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418c94f0"]])

export default __exports__